<template>
  <div id="form-base" class="relative flex">
    <div
      id="form-panel"
      class="form-base relative w-120 flex flex-col justify-between gap-12 flex-shrink-0 overflow-y-auto bg-pure-white border-r border-slate-400"
    >
      <div>
        <div
          class="sticky top-0 z-10 px-6 h-12 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400"
        >
          <BlBreadcrumbs :breadcrumbs="breadcrumbs" />
        </div>
        <div
          class="sticky top-12 z-10 px-6 h-22 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400"
        >
          <BlTextTitle3 text="Parents' Form" />
        </div>
        <ParentFormPanel />
      </div>
      <div
        class="sticky bottom-0 h-14 w-full flex-shrink-0 flex items-center justify-center gap-2 bg-pure-white border-t border-slate-400 hover:bg-hover-state"
        :class="[newSectionLoading ? 'pointer-events-none' : 'cursor-pointer']"
        @click="onAddsection"
      >
        <div
          class="h-6 w-6 flex-shrink-0 flex items-center justify-center rounded bg-red-salmon"
        >
          <BlIcon
            icon="rectangle-dashed"
            color="white"
            class="w-4 h-4"
            tooltip="Section"
          />
        </div>
        <BlTextSubtitle3 text="Add section" class="text-light-purple" />
        <div v-if="newSectionLoading" class="blum-loader-sm"></div>
      </div>
    </div>
    <div
      id="form-body"
      class="form-base relative overflow-y-auto"
      :style="{ width: 'calc(100vw - 30rem)' }"
    >
      <div
        class="sticky top-0 z-10 px-6 h-16 flex items-center justify-end bg-slate-300 border-b border-slate-400"
      >
        <router-link
          to="/center/client-acquisition/form/preview"
          target="_blank"
        >
          <BlInputButton label="Preview form" />
        </router-link>
      </div>
      <div v-if="fetchLoading" class="h-full grid place-items-center">
        <div class="blum-loader"></div>
      </div>
      <div
        v-else-if="parentForm"
        :key="parentForm.updated_at"
        class="w-full py-5 flex flex-col items-center gap-5"
      >
        <div
          class="w-148 py-6 flex flex-col items-center bg-pure-white border-l-8 border-light-purple-200 rounded-xl"
        >
          <input
            type="text"
            name="form_name"
            id="form_name"
            class="name-input mb-2 focus:border-light-purple"
            placeholder="Form title"
            v-model="nameInput"
          />
          <textarea
            type="text"
            name="form_description"
            id="form_description"
            class="description-input focus:border-light-purple"
            placeholder="Description (optional)"
            v-model="descriptionInput"
          ></textarea>
        </div>
        <ParentFormSection
          v-for="section in parentFormSections"
          :key="section.id"
          :section="section"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import debounce from "lodash/debounce";

import ParentFormPanel from "./parentForm/Panel.vue";
import ParentFormSection from "./parentForm/Section.vue";

import BlBreadcrumbs from "../../BlBreadcrumbs.vue";
import BlTextTitle3 from "../../BlTextTitle3.vue";
import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlIcon from "../../BlIcon.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "CenterSalesPipelineForm",
  components: {
    ParentFormPanel,
    ParentFormSection,
    BlBreadcrumbs,
    BlTextTitle3,
    BlTextSubtitle3,
    BlTextBody2,
    BlIcon,
    BlInputButton
  },
  data() {
    return {
      fetchLoading: false,
      saveLoading: false,
      nameInput: "",
      descriptionInput: "",
      newSectionLoading: false
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter", "parentForm", "parentFormSections"]),
    enableSalesPipeline() {
      return this.currentCenter.enable_sales_pipeline;
    },
    breadcrumbs() {
      return [
        {
          label: "Client Acquisition Board",
          target: `/center/client-acquisition`
        },
        {
          label: "Parent's Form",
          target: `/center/client-acquisition/form`
        }
      ];
    }
  },
  watch: {
    nameInput(val) {
      if (val && val !== this.parentForm.name) {
        this.onEditing();
      }
    },
    descriptionInput(val) {
      if (val !== this.parentForm.description) {
        this.onEditing();
      }
    }
  },
  mounted() {
    if (!this.currentUser.role.includes("admin")) {
      return this.$router.push({ name: "Clients" });
    }
    if (!this.enableSalesPipeline) {
      return this.$router.push({ name: "Clients" });
    }
    this.fetchParentForm();
  },
  destroyed() {
    const app = document.getElementById("app");
    if (app) app.scroll({ top: 0, left: 0 });
  },
  methods: {
    ...mapActions([
      "getParentForm",
      "updateParentForm",
      "createParentFormSection"
    ]),
    fetchParentForm() {
      this.fetchLoading = true;
      this.getParentForm().then(({ success, data }) => {
        this.fetchLoading = false;
        if (!success) return;
        this.nameInput = data.name;
        this.descriptionInput = data.description;
      });
    },
    onEditing: debounce(function() {
      const data = {
        id: this.parentForm.id,
        form: {
          name: this.nameInput,
          description: this.descriptionInput
        }
      };
      this.saveLoading = true;
      this.updateParentForm(data).then(({ success }) => {
        this.saveLoading = false;
        if (!success) {
          this.nameInput = this.parentForm.name;
          this.descriptionInput = this.parentForm.description;
          // return;
        }
      });
    }, 1000),
    onAddsection() {
      const data = {
        form_id: this.parentForm.id,
        section: { name: "New section" }
      };
      this.newSectionLoading = true;
      this.createParentFormSection(data).then(() => {
        this.newSectionLoading = false;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.form-base {
  // height: calc(100vh - 4.5rem);
  height: calc(100vh - 4.5rem);
  .name-input {
    width: 32rem;
    height: 2.5rem;
    padding: 4px 8px 4px 8px;
    border-radius: 5px;
    border: 1px solid var(--Slate-5, #d0d5dd);
    //
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 2rem;
    letter-spacing: 0.5px;
    text-align: left;
    color: var(--Slate-10, #1d2939);
    //
    outline: none;
  }
  .description-input {
    width: 32rem;
    height: 6.25rem;
    padding: 4px 8px 4px 8px;
    border-radius: 5px;
    border: 1px solid var(--Slate-5, #d0d5dd);
    //
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.375rem;
    letter-spacing: 0.5px;
    text-align: left;
    color: var(--Slate-7, #475467);
    //
    outline: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/center/salesPipeline/Form.vue